import { useColorScheme } from "nativewind"
import "./global.css"

export { useColorScheme }
export * from "nativewind"
